// ErrorBoundary.jsx
import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("🧯 ErrorBoundary caught an error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return <h2>Something went wrong while rendering the map.</h2>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
